import {
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";

export const MOUSE_ACTIVATION_DISTANCE = 8;
export const TOUCH_ACTIVATION_DELAY_MS = 200;
export const TOUCH_ACTIVATION_TOLERANCE = 8;

export function useLessonDndSensors() {
  return useSensors(
    useSensor(MouseSensor, {
      activationConstraint: {
        distance: MOUSE_ACTIVATION_DISTANCE,
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: TOUCH_ACTIVATION_DELAY_MS,
        tolerance: TOUCH_ACTIVATION_TOLERANCE,
      },
    }),
  );
}
